import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import styles from './AsnWarningDialog.module.css';
import Warning from '../../icons/warning.svg';

const AsnWarningDialog = ({ generateAsn, handleClose, open }) => {
  return (
    <Dialog open={open}>
      <DialogContent>
        <div className={styles.title}>
          <div className={styles.mdlTitle}>
            <span className={styles.icimage}>
              {' '}
              <img src={Warning} alt="Warning" className={styles.icWarning} />
            </span>

            <span className={styles.txt}>Warning</span>
          </div>
        </div>
        <div className={styles.warningTitle}>Please Note !!!</div>
        <p className={styles.warningText}>
          Once ASN is generated, you will not be allowed to edit the Plan for
          these dates, Do you still want to Generate ASN ?
        </p>
      </DialogContent>
      <DialogActions className={styles.buttonsBar}>
        <Button
          onClick={handleClose}
          variant="contained"
          className={styles.editButton}
        >
          Edit
        </Button>
        <Button
          onClick={() => {
            handleClose();
            generateAsn();
          }}
          variant="contained"
          className={styles.generateButton}
        >
          Generate ASN
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AsnWarningDialog.propTypes = {
  generateAsn: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default AsnWarningDialog;
